import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8f2c3f30"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Найти")
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Добавить ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_plus_outlined = _resolveComponent("plus-outlined")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_meet_modal = _resolveComponent("meet-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_row, { justify: "space-between" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_typography_title, { level: 3 }, {
              default: _withCtx(() => [
                _createTextVNode(" Встречи на " + _toDisplayString(_ctx.moment().format("YYYY.MM.DD")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_range_picker, {
              value: _ctx.dateRange,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dateRange) = $event)),
              "value-format": "YYYY-MM-DD",
              allowClear: false,
              ranges: _ctx.ranges,
              locale: _ctx.locale
            }, null, 8, ["value", "ranges", "locale"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, { onClick: _ctx.findMeets }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _hoisted_2,
    _createVNode(_component_a_row, { gutter: [8, 16] }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.agents, (agent) => {
          return (_openBlock(), _createBlock(_component_a_col, {
            key: agent.id,
            xs: 24,
            sm: 24,
            md: 12,
            lg: 12,
            xl: 8
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_table, {
                columns: _ctx.columns,
                "data-source": _ctx.meets.meetsToday[agent.id],
                size: "small",
                bordered: "",
                locale: { emptyText: 'Нет встреч на сегодня' },
                pagination: false,
                "custom-row": _ctx.handleClickRow,
                scroll: { y: 195 },
                style: {"background":"antiquewhite"},
                "row-class-name": 
          (record) => {
            if (record.result === 'Отмена') {
              return 'table-row-cancel';
            }

            if (record.adjustment) {
              return 'table-row-adjustment';
            }
          }
        
              }, {
                title: _withCtx(() => [
                  _createVNode(_component_a_row, { justify: "space-between" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_typography_title, { level: 5 }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(agent.name) + " - " + _toDisplayString(agent.phoneNumber), 1)
                        ]),
                        _: 2
                      }, 1024),
                      (!_ctx.state.user.roles.includes('AGENT'))
                        ? (_openBlock(), _createBlock(_component_a_button, {
                            key: 0,
                            onClick: ($event: any) => (_ctx.showMeetModal(agent))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_3
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                bodyCell: _withCtx(({ column, text, record }) => [
                  (column.dataIndex === 'time')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.moment(text).startOf("minute").format("HH:mm")), 1)
                      ], 64))
                    : _createCommentVNode("", true),
                  (column.dataIndex === 'address')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(record.street) + " " + _toDisplayString(record.house), 1)
                      ], 64))
                    : _createCommentVNode("", true),
                  (column.dataIndex === 'manager')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createTextVNode(_toDisplayString(text.name), 1)
                      ], 64))
                    : _createCommentVNode("", true),
                  (column.dataIndex === 'note')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        text
                          ? (_openBlock(), _createBlock(_component_plus_outlined, { key: 0 }))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["columns", "data-source", "custom-row", "row-class-name"]),
              _createVNode(_component_a_table, {
                columns: _ctx.columns,
                "data-source": _ctx.meets.meetsFuture[agent.id],
                "show-header": false,
                size: "small",
                locale: { emptyText: 'Нет встреч на след. дни' },
                pagination: false,
                "custom-row": _ctx.handleClickRow,
                scroll: { y: 110 },
                bordered: "",
                class: "ant-table-striped",
                "row-class-name": "table-striped"
              }, {
                bodyCell: _withCtx(({ column, text, record }) => [
                  (column.dataIndex === 'time')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.moment(text).startOf("minute").format("HH:mm")), 1)
                      ], 64))
                    : _createCommentVNode("", true),
                  (column.dataIndex === 'address')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(record.street) + " " + _toDisplayString(record.house), 1)
                      ], 64))
                    : _createCommentVNode("", true),
                  (column.dataIndex === 'manager')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createTextVNode(_toDisplayString(text.name), 1)
                      ], 64))
                    : _createCommentVNode("", true),
                  (column.dataIndex === 'note')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        text
                          ? (_openBlock(), _createBlock(_component_plus_outlined, { key: 0 }))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["columns", "data-source", "locale", "custom-row"])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }),
    (_ctx.modalVisible)
      ? (_openBlock(), _createBlock(_component_meet_modal, {
          key: 0,
          onHideModal: _ctx.hideModal,
          agents: _ctx.agents,
          managers: _ctx.managers,
          "meet-id": _ctx.meetId,
          "agent-id": _ctx.agentId
        }, null, 8, ["onHideModal", "agents", "managers", "meet-id", "agent-id"]))
      : _createCommentVNode("", true)
  ], 64))
}